import OutstandingItemsSection from "@/components/serviceFlow/client/outstandingItemsSection";
import useOutstandingItems from "@/components/serviceFlow/client/useOutstandingItems";
import { ClientByTokenQuery } from "@/graphql/queries/clientByToken.graphql.types";
import useClientFormsByToken from "@/hooks/client/useClientFormsByToken";

type Visit =
  ClientByTokenQuery["clientAccessTokenByPk"]["client"]["visits"][number];

type Props = {
  visits: Visit[];
  forms: ReturnType<typeof useClientFormsByToken>["forms"];
};

export default function OutstandingItems({ visits, forms }: Props) {
  const {
    unsignedForms,
    toConfirm,
    isConfirmingAppointment,
    confirmAppointmentAction,
  } = useOutstandingItems(visits, forms);

  if (!unsignedForms.length && !toConfirm.length) return undefined;

  return (
    <OutstandingItemsSection
      isConfirmingAppointment={isConfirmingAppointment}
      confirmAppointmentAction={confirmAppointmentAction}
      toConfirm={toConfirm}
      unsignedForms={unsignedForms}
    />
  );
}
